import axios from "axios";

export default class Surveys {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }
  async getAllPoints(page = 0, limit = 10, published = false) {
    try {
      const response = await axios({
        method: "get",
        url: `${
          this.API_LINK
        }/interactiveMap?limit=${limit}&published=${published}&page=${page}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getDownloadLink() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/interactiveMap/download`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async editPoint(params, id) {
    try {
      const response = await axios({
        method: "patch",
        url: `${this.API_LINK}/interactiveMap/${id}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getAllCategorys(language) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/interactiveMap/category`,
        headers: {
          "accept-language": language
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async statusInterval(url) {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const resp = await this.getUploadStatus(url);
          if (resp.data.status == true) {
            resolve(resp);
            clearInterval(interval);
          }
        } catch (error) {
          reject(error);
        }
      }, 10000);
    });
  }
  async getUploadStatus(url) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}${url}`
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
  async uploadInteractiveMap(bucket, key) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/interactiveMap/sync`,
        data: {
          srcBucket: bucket,
          src: key
        }
      });
      if (response.data.statusCode == 502) throw response;
      return response;
    } catch (error) {
      if (error.data && error.data.statusCode == 502) throw error.data;
      try {
        await this.statusInterval("/interactiveMap/sync");
      } catch (error) {
        throw error;
      }
    }
  }
  async postInteractiveFile(url, fileName) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/files/`,
        data: {
          fileName: fileName,
          source: url
        }
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }
  async getInteractiveFiles() {
    try {
      const requests = [
        axios({
          method: "get",
          url: `${this.API_LINK}/bin/files/prod_interactive`
        })
      ];
      const response = await Promise.all(requests);
      return response.map(resp => resp.data);
    } catch (error) {
      throw error;
    }
  }
}
